import { useFeature } from '@growthbook/growthbook-react';
import FEATURES from '../constants/featureToggling';

export const useIsFavouriteGamesEnabled = () => {
  return useFeature(FEATURES.ENABLED_FAVORITE_GAMES).on;
};
